module.exports = __webpack_public_path__ + "static/media/wallpaper6.e3205307.jpg";